module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-open-book",
    attrs: {
      "id": "selGoods"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sel-goods-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "common-tit"
  }, [_c('span', {
    staticClass: "tit-info"
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "left-cont common-cont"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'cont-list over' : 'cont-list'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list-filter"
  }, [_c('span', {
    staticClass: "name-filter filter-normal",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal search",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo",
    on: {
      "click": function($event) {
        return _vm.searchGoods()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticClass: "add",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.modifyItem('add', item)
        }
      }
    }, [_vm._v("添加")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 9 ? 'right-cont common-cont over' : 'right-cont common-cont'
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 10 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.nowSelectGoods), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', {
      staticClass: "ruduce",
      staticStyle: {
        "width": "25%"
      },
      on: {
        "click": function($event) {
          return _vm.modifyItem('reduce', item)
        }
      }
    }, [_c('span', [_vm._v("删减")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-set"
  }, [_c('button', {
    staticStyle: {
      "background": "#ccc"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selOk
    }
  }, [_vm._v("完成")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit active"
  }, [_c('span', [_vm._v("可选配品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("已选配品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-34436289","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/selPeiGoods/selGoods.vue
// module id = 939
// module chunks = 1